<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Download', isDisabled: !amountToPrint || downloading, spin:downloading}
  ]"
  (action)="action($event)"
  (close)="action($event)"
>
  <div class="body_modal_logistics pt-4">
    <form>
      <p class="font-weight-600">{{data.accountType === 'Walmart' ? 'Count' : data.title == 'Print Shipping Labels' ? 'Number of boxes :' : '# of Pallets (x4) :'}}</p>
      <div class="mt-1 amount_pickup d-flex align-items-center input-container">
        <div class="select_holder position-relative">
          <input
            #input
            type="number"
            numbersOnly
            [(ngModel)]="amountToPrint"
            class="input-container_input"
            name="amountToPrint"
            id="amountToPrint"
            [min]="data.isBuyShip ? data.amountToPrint : 0"
            [readonly]="data.isBuyShip &&  data.isSPD"
          />
        </div>
      </div>

      <div class="gap_top_3pt4" *ngIf="data.accountType === 'Amazon' || !data.isPalletlable">
        <label for="" class="font-weight-600 tk-roc-grotesk"
          >Select Template:
        </label>
        <div class="select_holder position-relative">
          <select
            name="permission_role"
            id="permission_role"
            [(ngModel)]="lableType"
            class="form-control"
          >
            <option [value]="item.value" *ngFor="let item of types">{{item.text}}</option>
          </select>
          <i class="fal fa-angle-down"></i>
        </div>
      </div>

      <!--<div class="gap_top_3pt4" *ngIf="data.isBuyShip &&  data.isSPD">
        <label for="" class="font-weight-600 tk-roc-grotesk"
          >Select Label Type:
        </label>
        <div class="select_holder position-relative">
          <select
            name="spdType"
            id="spdType"
            [(ngModel)]="SPDLabelType"
            class="form-control"
          >
            <option [value]="item.value" *ngFor="let item of SPDType">{{item.text}}</option>
          </select>
          <i class="fal fa-angle-down"></i>
        </div>
      </div>-->

    </form>
  </div>
</app-dialog>
